window.addEventListener('load', () => {
    // Tag pill navigation on news cards
    document.addEventListener('click', (e) => {
        const pill = e.target.closest('.news-tag-pill');
        if (pill) {
            e.preventDefault();
            e.stopPropagation();
            const url = pill.dataset.tagUrl;
            if (!url) return;

            // If already on the news list page, update the filter directly
            const tagName = new URL(url, window.location.origin).searchParams.get('tag');
            const filterContainer = document.querySelector('.filters-container');
            if (tagName && filterContainer) {
                const tagCheckboxes = filterContainer.querySelectorAll('input[type="checkbox"][data-for="Tags"]');
                let found = false;
                tagCheckboxes.forEach((cb) => {
                    if (cb.value === tagName) {
                        cb.checked = !cb.checked;
                        cb.dispatchEvent(new Event('change', { bubbles: true }));
                        found = true;
                    }
                });
                if (found) {
                    filterContainer.scrollIntoView({ behavior: 'smooth' });
                    return;
                }
            }

            window.location.href = url;
        }
    });

    const recentNewsPanels = document.querySelectorAll('.recent-news-panel');

    for (const recentNewsPanel of recentNewsPanels) {
        let cardLimit = recentNewsPanel.querySelector('[data-card-limit]').dataset.cardLimit;
        if (cardLimit) {
            cardLimit = parseInt(cardLimit);
            const publicationCards = recentNewsPanel.querySelectorAll('[data-news-card]');
            const defaultVisibleCount = cardLimit;
            const tagToggles = recentNewsPanel.querySelectorAll('button[data-toggle-tag]');
            let currentlyVisibleCount = defaultVisibleCount;
            let activeTag = "View All"; // Default tag to show all cards

            // Helper to get the tag from query parameters
            function getQueryParam(param) {
                const urlParams = new URLSearchParams(window.location.search);
                return urlParams.get(param);
            }

            // Set initial tag based on query parameter if valid
            const queryTag = getQueryParam('tag');
            if (queryTag) {
                const matchingTagToggle = Array.from(tagToggles).find(tagToggle => tagToggle.dataset.toggleTag === queryTag);
                if (matchingTagToggle) {
                    activeTag = queryTag;
                    for (const tagToggle of tagToggles) {
                        tagToggle.dataset.active = 'false';
                    }
                    matchingTagToggle.dataset.active = 'true';
                }
            }

            function updateVisibility() {
                let visibleCount = 0;

                publicationCards.forEach(publicationCard => {
                    const matchesTag = activeTag === "View All" ||
                        (publicationCard.dataset.tags ?
                                publicationCard.dataset.tags.split(',').map(tag => tag.trim()) : []
                        ).includes(activeTag);

                    // Only set active if matches tag and within the visible count
                    const isVisible = matchesTag && visibleCount < currentlyVisibleCount;
                    publicationCard.dataset.active = isVisible ? 'true' : 'false';

                    // Increment visible count for matching cards
                    if (matchesTag && visibleCount < currentlyVisibleCount) {
                        visibleCount++;
                    }
                });

                const showMoreBtn = recentNewsPanel.querySelector('[data-button-show="more"]');
                const showLessBtn = recentNewsPanel.querySelector('[data-button-show="less"]');

                const totalMatchingCards = Array.from(publicationCards).filter(card =>
                    activeTag === "View All" ||
                    (card.dataset.tags ? card.dataset.tags.split(',').map(tag => tag.trim()).includes(activeTag) : false)
                ).length;

                if (visibleCount < totalMatchingCards) {
                    showMoreBtn?.classList.remove('hidden');
                } else {
                    showMoreBtn?.classList.add('hidden');
                }

                if (visibleCount > defaultVisibleCount) {
                    showLessBtn?.classList.remove('hidden');
                } else {
                    showLessBtn?.classList.add('hidden');
                }
            }

            recentNewsPanel.addEventListener('click', (event) => {
                const clickedShowMore = event.target.closest('button[data-button-show="more"]');
                const clickedShowLess = event.target.closest('button[data-button-show="less"]');
                const clickedToggleTag = event.target.closest('button[data-toggle-tag]');

                if (clickedShowMore) {
                    currentlyVisibleCount = Math.min(currentlyVisibleCount + defaultVisibleCount, publicationCards.length);
                    updateVisibility();
                }

                if (clickedShowLess) {
                    currentlyVisibleCount = defaultVisibleCount;
                    updateVisibility();
                    if (window.innerWidth < 768) {
                        recentNewsPanel.scrollIntoView({ behavior: 'smooth' });
                    }
                }

                if (clickedToggleTag) {
                    for (const tagToggle of tagToggles) {
                        tagToggle.dataset.active = 'false';
                    }
                    clickedToggleTag.dataset.active = 'true';
                    activeTag = clickedToggleTag.dataset.toggleTag;
                    currentlyVisibleCount = defaultVisibleCount;
                    updateVisibility();
                }
            });

            // Initial visibility update
            updateVisibility();
        }
    }
});
